import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import ContentCarousel from '@justpark/ui/src/components/ContentCarousel';
import Typography from '@justpark/ui/src/components/Typography';
import trustPilot from '../../../static/images/landing/trustpilotCustomerReviews.png';
import useLandingData from '../../pages/landingV2/useLandingData';

import styles from '../../../static/scss/components/landing/reviews.module.scss';

const Reviews = () => {
  const reviews = useLandingData()?.reviews;

  return (
    <div className={styles.base}>
      <div className={styles.image}>
        <img
          src={trustPilot}
          alt="Trustpilot reviews"
          width={124}
          height={115}
          loading="lazy"
        />
      </div>

      <div className={styles.reviews}>
        <ContentCarousel
          items={useMemo(
            () =>
              reviews.map(({ comment, sender, location }) => (
                <Link key={sender} to={location.slug}>
                  <div data-cy="review-item" className={styles.reviewItem}>
                    <div className={styles.location}>
                      <Typography size="subtext">
                        <Typography bold>{sender}</Typography> JustParked at{' '}
                        <Typography color="muted">{location.title}</Typography>
                      </Typography>
                    </div>

                    <Typography size="subtext">
                      <q>{comment}</q>
                    </Typography>
                  </div>
                </Link>
              )),
            [reviews]
          )}
        />
      </div>
    </div>
  );
};

export default Reviews;
